module.exports = __webpack_public_path__ + "static/media/tower_icon.7c29884e.svg";